import CONSTANTS from 'chat-constants';
import { GECKO_CONSTS } from 'ui/constants/index';
import { LANGUAGES, LANGUAGE_OPTIONS } from './languages';
import { COUNTRIES, COUNTRY_OPTIONS } from './countries';
import {
  FILTER_MY_CONVERSATIONS,
  FILTER_UNASSIGNED,
  FILTER_OPEN,
  FILTER_CLOSED,
  FILTER_SENT,
  FILTER_ASSIGNED_TO_BOT,
  FILTER_CONTACT_OPEN,
  FILTER_CONTACT,
  FILTER_CUSTOM_FILTER,
  FILTER_TAG,
  FILTER_UNDELIVERED,
  FILTERS_SHOWING_UNREAD_MESSAGES,
} from './filters';
import FEATURES from './features';
import PERMISSIONS from './permissions';
import CONVERSATION_FILTERS from './conversationFilters';
import MESSAGES from 'chat-constants/message';

let CONSTS = {};
CONSTS.LANGUAGES = LANGUAGES;
CONSTS.LANGUAGE_OPTIONS = LANGUAGE_OPTIONS;
CONSTS.COUNTRIES = COUNTRIES;
CONSTS.COUNTRY_OPTIONS = COUNTRY_OPTIONS;
CONSTS.FEATURES = FEATURES;
CONSTS.PERMISSIONS = PERMISSIONS;
CONSTS.CONVERSATION_FILTERS = CONVERSATION_FILTERS;

CONSTS.FILTER_MY_CONVERSATIONS = FILTER_MY_CONVERSATIONS;
CONSTS.FILTER_UNASSIGNED = FILTER_UNASSIGNED;
CONSTS.FILTER_OPEN = FILTER_OPEN;
CONSTS.FILTER_CLOSED = FILTER_CLOSED;
CONSTS.FILTER_SENT = FILTER_SENT;
CONSTS.FILTER_ASSIGNED_TO_BOT = FILTER_ASSIGNED_TO_BOT;
CONSTS.FILTER_CONTACT_OPEN = FILTER_CONTACT_OPEN;
CONSTS.FILTER_CONTACT = FILTER_CONTACT;
CONSTS.FILTER_CUSTOM_FILTER = FILTER_CUSTOM_FILTER;
CONSTS.FILTER_TAG = FILTER_TAG;
CONSTS.FILTER_UNDELIVERED = FILTER_UNDELIVERED;

CONSTS.FILTERS_SHOWING_UNREAD_MESSAGES = FILTERS_SHOWING_UNREAD_MESSAGES;

// Agents
CONSTS.AGENT_STATUS_ACTIVE = 'Active';
CONSTS.AGENT_STATUS_ONLINE = 'Online';
CONSTS.AGENT_STATUS_OFFLINE = 'Offline';
CONSTS.AGENT_STATUS_AWAY = 'Away';
CONSTS.AGENT_STATUS_UNKNOWN = 'Unkown';

CONSTS.AGENT_STATUS_STYLES = [
  {
    key: CONSTS.AGENT_STATUS_ACTIVE,
    type: GECKO_CONSTS.STATUS_TYPE_SUCCESS,
    name: CONSTS.AGENT_STATUS_ACTIVE,
  },
  {
    key: CONSTS.AGENT_STATUS_ONLINE,
    type: GECKO_CONSTS.STATUS_TYPE_SUCCESS,
    name: CONSTS.AGENT_STATUS_ONLINE,
  },
  {
    key: CONSTS.AGENT_STATUS_OFFLINE,
    name: CONSTS.AGENT_STATUS_OFFLINE,
  },
  {
    key: CONSTS.AGENT_STATUS_AWAY,
    type: GECKO_CONSTS.STATUS_TYPE_WARNING,
    name: CONSTS.AGENT_STATUS_AWAY,
  },
  {
    key: CONSTS.AGENT_STATUS_UNKNOWN,
    type: GECKO_CONSTS.STATUS_TYPE_INFO,
    name: CONSTS.AGENT_STATUS_UNKNOWN,
  },
];

// Channels
CONSTS.EDITOR_MODE_TYPE = {
  RICH: 'rich',
  PLAIN: 'plain',
  SEMI_RICH: 'semi-rich',
};

CONSTS.CHANNEL_CONTENT_TYPES = {
  [CONSTANTS.CHANNEL.TYPE_LIVE_CHAT]: CONSTS.EDITOR_MODE_TYPE.RICH,
  [CONSTANTS.CHANNEL.TYPE_FACEBOOK]: CONSTS.EDITOR_MODE_TYPE.PLAIN,
  [CONSTANTS.CHANNEL.TYPE_INSTAGRAM]: CONSTS.EDITOR_MODE_TYPE.PLAIN,
  [CONSTANTS.CHANNEL.TYPE_TWILIO]: CONSTS.EDITOR_MODE_TYPE.PLAIN,
  [CONSTANTS.CHANNEL.TYPE_TWITTER]: CONSTS.EDITOR_MODE_TYPE.PLAIN,
  [CONSTANTS.CHANNEL.TYPE_MAILGUN]: CONSTS.EDITOR_MODE_TYPE.SEMI_RICH,
  [CONSTANTS.CHANNEL.TYPE_WECHAT]: CONSTS.EDITOR_MODE_TYPE.PLAIN,
  [CONSTANTS.CHANNEL.TYPE_WHATSAPP]: CONSTS.EDITOR_MODE_TYPE.PLAIN,
  [CONSTANTS.CHANNEL.TYPE_INTERNAL_NOTE]: CONSTS.EDITOR_MODE_TYPE.RICH,
};

CONSTS.CHANNEL_STATUS_ACTIVE = 'active';
CONSTS.CHANNEL_STATUS_OFFLINE = 'offline';
CONSTS.CHANNEL_STATUS_PAUSED = 'paused';

CONSTS.MESSAGE_STATUS_SENDING = MESSAGES.STATUS_SENDING;
CONSTS.MESSAGE_STATUS_SENT = MESSAGES.STATUS_SENT;
CONSTS.MESSAGE_STATUS_DELIVERED = MESSAGES.STATUS_DELIVERED;
CONSTS.MESSAGE_STATUS_UNDELIVERED = MESSAGES.STATUS_UNDELIVERED;
CONSTS.MESSAGE_STATUS_RECIEVED = MESSAGES.STATUS_RECEIVED;
CONSTS.MESSAGE_STATUS_READ = MESSAGES.STATUS_READ;
CONSTS.MESSAGE_STATUS_FAILED = MESSAGES.STATUS_FAILED;
CONSTS.MESSAGE_STATUS_TEMPORARY_FAIL = MESSAGES.STATUS_TEMPORARY_FAIL;

CONSTS.MESSAGE_STATUSES = [
  CONSTS.MESSAGE_STATUS_SENDING,
  CONSTS.MESSAGE_STATUS_SENT,
  CONSTS.MESSAGE_STATUS_DELIVERED,
  CONSTS.MESSAGE_STATUS_UNDELIVERED,
  CONSTS.MESSAGE_STATUS_RECIEVED,
  CONSTS.MESSAGE_STATUS_READ,
  CONSTS.MESSAGE_STATUS_FAILED,
  CONSTS.MESSAGE_STATUS_TEMPORARY_FAIL,
];

CONSTS.MESSAGE_STATUS_ICON_CLASSES = {
  [CONSTS.MESSAGE_STATUS_SENDING]: 'far fa-pulse fa-spinner default-grey',
  [CONSTS.MESSAGE_STATUS_SENT]: 'far fa-paper-plane default-grey',
  [CONSTS.MESSAGE_STATUS_DELIVERED]: 'far fa-envelope default-grey',
  [CONSTS.MESSAGE_STATUS_UNDELIVERED]: 'fas fa-exclamation-triangle failed-red',
  [CONSTS.MESSAGE_STATUS_RECIEVED]: 'far fa-envelope default-grey',
  [CONSTS.MESSAGE_STATUS_READ]: 'far fa-envelope-open read-green',
  [CONSTS.MESSAGE_STATUS_FAILED]: 'fas fa-exclamation-triangle failed-red',
  [CONSTS.MESSAGE_STATUS_TEMPORARY_FAIL]:
    'fas fa-exclamation-triangle temporary-orange',
};

CONSTS.MESSAGE_STATUS_DESCRIPTIONS = {
  [CONSTS.MESSAGE_STATUS_SENDING]: 'This message is sending...',
  [CONSTS.MESSAGE_STATUS_SENT]: 'This message has been sent',
  [CONSTS.MESSAGE_STATUS_DELIVERED]: 'This message has been delivered',
  [CONSTS.MESSAGE_STATUS_UNDELIVERED]: 'This message cannot be delivered',
  [CONSTS.MESSAGE_STATUS_RECIEVED]: 'This message has been received',
  [CONSTS.MESSAGE_STATUS_READ]: 'This message has been read',
  [CONSTS.MESSAGE_STATUS_FAILED]: 'This message has failed to send',
  [CONSTS.MESSAGE_STATUS_TEMPORARY_FAIL]:
    'This message is undelivered. Attempting to resend(for up to 8 hours)',
};

CONSTS.BOT_SKILL_HANDOVER = { HANDOVER: 'workflow_action' };

CONSTS.SKILL_TYPES = {
  DATA_CAPTURE: {
    name: 'Data Capture',
    icon: 'far fa-clipboard-check',
  },
  DISPLAY_LIST: {
    name: 'Display List',
    icon: 'far fa-list-alt',
  },
  SUGGEST_ANSWER: {
    name: 'Suggest Answer',
    icon: 'far fa-question-circle',
  },
  GECKO_FORM: {
    name: 'Gecko Form',
    icon: 'far fa-clipboard-list-check',
  },
  WORKFLOW_ACTION: {
    name: 'Workflow Action',
    icon: 'far fa-cogs',
  },
};

CONSTS.IMPORT_STATUS_NEW = 'NEW';
CONSTS.IMPORT_STATUS_PROCESSING = 'PROCESSING';
CONSTS.IMPORT_STATUS_FAILED_VALIDATION = 'FAILED_VALIDATION';
CONSTS.IMPORT_STATUS_REVIEW = 'REVIEW';
CONSTS.IMPORT_STATUS_COMMITTED = 'COMMITTED';
CONSTS.IMPORT_STATUS_COMPLETED = 'COMPLETED';

CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED = 'NOT_REVIEWED';
CONSTS.DELTA_REVIEW_STATUS_APPROVED = 'APPROVED';
CONSTS.DELTA_REVIEW_STATUS_REJECTED = 'REJECTED';
CONSTS.DELTA_SAMPLE_ADD = 'SAMPLE_ADD';
CONSTS.DELTA_SAMPLE_REMOVE = 'SAMPLE_REMOVE';
CONSTS.DELTA_ANSWER_ADD = 'ANSWER_ADD';
CONSTS.DELTA_ANSWER_REMOVE = 'ANSWER_REMOVE';
CONSTS.DELTA_SKILL_ADD = 'SKILL_ADD';
CONSTS.DELTA_SKILL_REMOVE = 'SKILL_REMOVE';
CONSTS.DELTA_TAG_ADD = 'TAG_ADD';
CONSTS.DELTA_TAG_REMOVE = 'TAG_REMOVE';

CONSTS.IMAGE_ACCEPT_MIME_TYPES = 'image/png,image/jpeg,image/gif';
CONSTS.DOCUMENT_ACCEPT_MIME_TYPES =
  'text/plain,application/vnd.oasis.opendocument.text,application/vnd.openxmlformats-officedocument.wordprocessingm,application/vnd.ms-excel,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
CONSTS.ATTACHMENT_ACCEPT_MIME_TYPES =
  CONSTS.IMAGE_ACCEPT_MIME_TYPES + ',' + CONSTS.DOCUMENT_ACCEPT_MIME_TYPES;

export { CONSTS };

export default CONSTS;
